<template>
  <section class="nup-reward">
    <h2 class="nup-reward__title">
      <span
        v-for="(line, index) in titleLines"
        :key="index"
        class="nup-reward__title-line"
      >{{ line }}</span>
    </h2>
    <CountdownText
      v-if="showCountdown"
      :end-at="depositEndTime"
    />
    <p
      v-else-if="showAwarded"
      class="nup-reward__sub"
    >
      {{ awardedSub }}
    </p>
    <p
      v-else-if="showMissed"
      class="nup-reward__sub"
    >
      {{ copy.subMissed }}
    </p>
    <p
      v-else
      class="nup-reward__sub"
    >
      {{ defaultSub }}
    </p>

    <AwardedPanel
      v-if="showAwarded || showMissed"
      :images="awardedImages"
      :show-view="showAwarded"
      @view="$emit('view-prize')"
    />
    <RewardTierList
      v-else
      :choice-key="choiceKey"
      :show-choice-btn="showChoiceBtn"
      :enrolled="enrolled"
      :net-deposit-amount="netDepositAmount"
      @pick="$emit('pick', $event)"
    />

    <div
      v-if="showDepositBtn"
      data-nup-cta
      class="nup-reward__cta"
    >
      <button
        type="button"
        class="nup-reward__enroll"
        :style="{ backgroundImage: 'url(' + btnBg + ')' }"
        @click="$emit('deposit')"
      >
        {{ copy.depositNow }}
      </button>
    </div>

    <div class="nup-reward__terms">
      <p
        v-for="(line, index) in terms"
        :key="index"
      >
        {{ line }}
      </p>
    </div>
  </section>
</template>

<script lang="ts">
import { computed } from 'vue-demi';
import { getCopy } from '../constants/copy';
import { useNupLang } from '../composables/use-nup-lang';
import { usePageTypeFlag } from '../composables/use-page-type';
import { formatAwardedSub } from '../utils/progress-stage';
import btnBg from '../assets/rewards/btn-bg.png';
import AwardedPanel from './awarded-panel.vue';
import CountdownText from './countdown-text.vue';
import RewardTierList from './reward-tier-list.vue';
const __sfc_main = {};
__sfc_main.props = {
  showAwarded: {
    type: Boolean,
    default: false
  },
  showMissed: {
    type: Boolean,
    default: false
  },
  showCountdown: {
    type: Boolean,
    default: false
  },
  showChoiceBtn: {
    type: Boolean,
    default: false
  },
  showDepositBtn: {
    type: Boolean,
    default: false
  },
  depositEndTime: {
    type: Number,
    default: 0
  },
  awardedImages: {
    type: Array,
    default: () => []
  },
  choiceKey: {
    type: String,
    default: ''
  },
  enrolled: {
    type: Boolean,
    default: false
  },
  netDepositAmount: {
    type: Number,
    default: null
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const {
    isPC
  } = usePageTypeFlag();
  const {
    isEn
  } = useNupLang();
  const copy = computed(() => getCopy(isEn.value));
  const terms = computed(() => copy.value.terms);
  const defaultSub = computed(() => {
    return isPC.value ? copy.value.subDefaultPc : copy.value.subDefaultH5;
  });
  const awardedSub = computed(() => {
    return formatAwardedSub(props.netDepositAmount, isEn.value);
  });
  const moduleTitle = computed(() => {
    if (props.showAwarded) {
      return copy.value.titleAwarded;
    }
    if (props.showMissed) {
      return copy.value.titleMissed;
    }
    return copy.value.titleDefault;
  });
  const titleLines = computed(() => {
    if (isPC.value) {
      return [moduleTitle.value.replace(/\n/g, ' ')];
    }
    return moduleTitle.value.split('\n');
  });
  return {
    btnBg,
    copy,
    terms,
    defaultSub,
    awardedSub,
    titleLines
  };
};
__sfc_main.components = Object.assign({
  CountdownText,
  AwardedPanel,
  RewardTierList
}, __sfc_main.components);
export default __sfc_main;
</script>

<style scoped>
.nup-reward {
  padding: 56px 40px 90px;
  background: #f8f7f8;
}

.nup-reward__title {
  margin: 0 0 20px;
  font-size: 56px;
  font-weight: 800;
  color: #000;
  line-height: 1.2;
}

.nup-reward__sub {
  margin: 0 0 48px;
  font-size: 28px;
  color: #303030;
}

.nup-reward__cta {
  display: flex;
  justify-content: center;
  margin-top: 48px;
}

.nup-reward__enroll {
  display: block;
  width: 614px;
  height: 106px;
  padding: 0;
  border: none;
  background-color: transparent;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100% 100%;
  color: #fff;
  font-size: 40px;
  font-weight: 600;
  line-height: 106px;
  text-align: center;
  cursor: pointer;
}

.nup-reward__terms {
  width: 669px;
  max-width: 100%;
  margin: 56px auto 0;
  color: rgba(122, 122, 122, 0.7);
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%;
}

.nup-reward__terms p {
  margin: 0;
  color: rgba(122, 122, 122, 0.7);
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%;
}

.nup-page.is-pc .nup-reward {
  width: 1200px;
  max-width: 100%;
  margin: 0 auto;
  padding: 56px 0 80px;
  box-sizing: border-box;
}

.nup-reward__title-line {
  display: block;
}

.nup-page.is-h5.is-en .nup-reward__title {
  color: #000;
  font-family: 'BR Hendrix', Arial, sans-serif;
  font-size: 60px;
  font-style: normal;
  font-weight: 700;
  line-height: 100%;
}

.nup-page.is-h5.is-en .nup-reward__sub {
  color: #000;
  font-family: 'BR Hendrix', Arial, sans-serif;
  font-size: 28px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
  opacity: 0.8;
}

.nup-page.is-pc .nup-reward__title {
  margin-bottom: 12px;
  font-size: 54px;
  text-align: center;
}

.nup-page.is-pc .nup-reward__sub {
  margin-bottom: 40px;
  font-size: 16px;
  text-align: center;
}

.nup-page.is-pc.is-en .nup-reward__title {
  font-size: 54px;
}

.nup-page.is-pc.is-en .nup-reward__sub {
  color: #000;
  font-size: 24px;
  opacity: 0.8;
}

.nup-page.is-pc .nup-reward__cta {
  margin-top: 40px;
}

.nup-page.is-pc .nup-reward__enroll {
  width: 360px;
  height: 60px;
  font-size: 20px;
  line-height: 60px;
}

.nup-page.is-pc .nup-reward__terms {
  width: 1200px;
  /* max-width: 100%; */
  margin: 40px auto 0;
  font-size: 12px;
  line-height: 1.5;
  color: #888;
  text-align: center;
}

.nup-page.is-pc:not(.is-en) .nup-reward__terms {
  white-space: nowrap;
}

.nup-page.is-pc .nup-reward__terms p {
  margin: 0;
  font-size: 12px;
  line-height: 1.5;
  color: #888;
}
</style>
